<div mat-dialog-title>
  <div>{{ title }}</div>
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (data.line1) {
    <p class="line-1">{{ data.line1 }}</p>
  }
  @if (data.periods) {
    <div class="pay-period-select">
      <mat-label>Payment Period:</mat-label>
      <mat-form-field>
        <mat-select
          class="period-select"
          (selectionChange)="changePayPeriod($event)"
          panelClass="status-panel"
          placeholder="Select a Pay Period">
          @for (period of data.periods; track period) {
            <mat-option [value]="period.id">
              {{ period.startDate | date: 'shortDate' }} -
              {{ period.endDate | date: 'shortDate' }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-divider></mat-divider>
    </div>
  }

  @if (alreadyPaid !== null && calcs) {
    <div class="list-title">You are about to send the following payments:</div>
    <div class="payments">
      @if (getTotalPaid() > 0) {
        <div>
          <mat-divider></mat-divider>
          <div class="buyer-details">
            <div class="payment" [ngClass]="balance === 0 ? 'zero-balance' : ''">
              Beginning Stripe Balance:
              {{ balance | currency }}
            </div>
            @for (payment of getPayments(); track payment) {
              <div class="payment">
                <span class="site-name">{{ payment.name }}:</span>
                {{ payment.amount | currency }}
              </div>
            }
            <mat-divider></mat-divider>
            <div>
              Total Payments:
              {{ getTotalPaid() | currency }}
            </div>
            <div class="payment">
              Ending Stripe Balance:
              {{ balance - getTotalPaid() | currency }}
            </div>
            @if (balance - getTotalPaid() < 0) {
              <div class="error-message">
                This stripe balance is insufficient for the desired payment. Be advised that if you proceed with
                payment,
                some payments may fail.
              </div>
            }
          </div>
        </div>
      }
      <div class="list-title">
        @if (alreadyPaid > 0) {
          <span>
            Please note: {{ alreadyPaid }} site{{ alreadyPaid > 1 ? 's' : '' }} for this payment period
            {{ alreadyPaid > 1 ? 'have' : 'has' }} already been paid and will not be paid again.
          </span>
        }
      </div>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button (click)="onNoClick()" color="primary" data-cy="button-no" mat-stroked-button>Cancel</button>
  <div></div>
  <button
    (click)="onYesClick()"
    [disabled]="alreadyPaid === null"
    color="primary"
    data-cy="button-yes"
    mat-raised-button>
    Confirm
  </button>
</div>
